// extracted by mini-css-extract-plugin
export default {"group":"StarInput_group__hbAFj","star":"StarInput_star__s4Jib","filled":"StarInput_filled__qxrZD"};